<div class="bal__num-wrap" (click)="onClick()" [style.background-color]="backgroundColor()"
  [ngClass]="{ 'link': link()}">
  @if (displayValue()) {
  <div class="bal__num" [ngClass]="{ 'score': type() == 'score', 'small': type() == 'small' }" [style.color]="color()">
    {{ displayValue() }}</div>
  } @else {
  <div class="bal__num" [ngClass]="{ 'score': type() == 'score', 'small': type() == 'small' }" [style.color]="color()">
    &#8212;</div>
  }
  <div class="bal__num-text" [style.color]="highlight() ? 'white' : 'auto'">
    {{ label()}}</div>
  @if (tooltip()) {
  <div class="tooltip">{{ tooltip() }}</div>
  }
</div>
<div #dialog></div>